(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-filters"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const loadMoreBtn = document.getElementById("load-more");
  const filterToggle = document.querySelector(".filter-toggle");
  const sidebar = document.querySelector(".filters-sidebar");

  // Load More functionality
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener("click", function () {
      const nextUrl = this.getAttribute("data-next-url");
      if (!nextUrl) return;

      this.classList.add("loading");

      fetch(nextUrl)
        .then(response => response.text())
        .then(data => {
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(data, "text/html");
          const newProducts = htmlDoc.querySelectorAll("#product-grid .product-card");
          const grid = document.getElementById("product-grid");

          newProducts.forEach(product => {
            grid.appendChild(product);
          });

          const newNextBtn = htmlDoc.querySelector("#load-more");
          if (newNextBtn) {
            loadMoreBtn.setAttribute("data-next-url", newNextBtn.getAttribute("data-next-url"));
            loadMoreBtn.classList.remove("loading");
          } else {
            loadMoreBtn.remove();
          }
        })
        .catch(err => {
          console.error("Load more failed:", err);
          loadMoreBtn.classList.remove("loading");
        });
    });
  }

  // Mobile filter toggle
  if (filterToggle && sidebar) {
    filterToggle.addEventListener("click", function () {
      sidebar.classList.toggle("active");
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
